/** Maximum number of quarters to show in quarterly line/bar charts. */
export const MAX_QUARTERS_CHART = 8;
